module.exports = __webpack_public_path__ + "static/media/gc-taxi-ride.457acbf9.png";